import {
  SET_CENTROS_CUSTOS_ACTION,
  SET_SOLICITANTES_ACTION,
  SET_SEARCH_TEXT_ACTION,
  SET_EMPRESA_ACTION,
  SET_PRODUTO_ACTION,
  SET_PROJETO_ACTION,
  SET_GRUPO_ACTION,
  SET_DATA_INICIAL_ACTION,
  SET_DATA_FINAL_ACTION,
  SET_DATA_ENTREGA_INICIAL_ACTION,
  SET_DATA_ENTREGA_FINAL_ACTION,
  SET_URGENCIA_ACTION,
  SET_SHOW_ESPECIFICACAO_ACTION,
  SET_COMPRADORES_ACTION,
  SET_LOCAL_ENTREGA_ACTION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  RESET_PAGINATION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
  SET_SHOW_OBSERVACAO_INTERNA_ACTION,
  SET_SHOW_OBSERVACAO_EXTERNA_ACTION,
} from './actions.type';
import {
  SET_CENTROS_CUSTOS,
  SET_SOLICITANTES,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_GRUPO,
  SET_DATA_FINAL,
  SET_DATA_INICIAL,
  SET_DATA_ENTREGA_INICIAL,
  SET_DATA_ENTREGA_FINAL,
  SET_URGENCIA,
  SET_SHOW_ESPECIFICACAO,
  SET_COMPRADORES,
  SET_LOCAL_ENTREGA,
  SET_CURRENT_PAGE,
  SET_OFFSET,
  SET_FILTER,
  SET_LIST_OPTIONS,
  SET_CURRENT_SESSION_STATE,
  INIT_STATE,
  SET_SHOW_OBSERVACAO_EXTERNA,
  SET_SHOW_OBSERVACAO_INTERNA,
} from './mutations.type';

export default {
  [SET_CENTROS_CUSTOS_ACTION](context, centrosCustos) {
    context.commit(SET_CENTROS_CUSTOS, centrosCustos);
  },
  [SET_SOLICITANTES_ACTION](context, solicitantes) {
    context.commit(SET_SOLICITANTES, solicitantes);
  },
  [SET_SEARCH_TEXT_ACTION](context, text) {
    context.commit(SET_SEARCH_TEXT, text);
  },
  [SET_EMPRESA_ACTION](context, empresa) {
    context.commit(SET_EMPRESA, empresa);
  },
  [SET_LOCAL_ENTREGA_ACTION](context, localEntrega) {
    context.commit(SET_LOCAL_ENTREGA, localEntrega);
  },
  [SET_PRODUTO_ACTION](context, produto) {
    context.commit(SET_PRODUTO, produto);
  },
  [SET_PROJETO_ACTION](context, projeto) {
    context.commit(SET_PROJETO, projeto);
  },
  [SET_GRUPO_ACTION](context, grupo) {
    context.commit(SET_GRUPO, grupo);
  },
  [SET_DATA_INICIAL_ACTION](context, dataInicial) {
    context.commit(SET_DATA_INICIAL, dataInicial);
  },
  [SET_DATA_FINAL_ACTION](context, dataFinal) {
    context.commit(SET_DATA_FINAL, dataFinal);
  },
  [SET_DATA_ENTREGA_INICIAL_ACTION](context, dataEntregaInicial) {
    context.commit(SET_DATA_ENTREGA_INICIAL, dataEntregaInicial);
  },
  [SET_DATA_ENTREGA_FINAL_ACTION](context, dataEntregaFinal) {
    context.commit(SET_DATA_ENTREGA_FINAL, dataEntregaFinal);
  },
  [SET_URGENCIA_ACTION](context, urgencia) {
    context.commit(SET_URGENCIA, urgencia);
  },
  [SET_SHOW_ESPECIFICACAO_ACTION](context, showEspecificacao) {
    context.commit(SET_SHOW_ESPECIFICACAO, showEspecificacao);
  },
  [SET_SHOW_OBSERVACAO_EXTERNA_ACTION](context, showObservacaoExterna) {
    context.commit(SET_SHOW_OBSERVACAO_EXTERNA, showObservacaoExterna);
  },
  [SET_SHOW_OBSERVACAO_INTERNA_ACTION](context, showObservacaoInterna) {
    context.commit(SET_SHOW_OBSERVACAO_INTERNA, showObservacaoInterna);
  },
  [SET_COMPRADORES_ACTION](context, compradores) {
    context.commit(SET_COMPRADORES, compradores);
  },
  [RESET_PAGINATION](context) {
    context.commit(SET_CURRENT_PAGE, 1);
    context.commit(SET_OFFSET, 0);
  },
  [SET_FILTER_ACTION](context, filter) {
    context.commit(SET_FILTER, filter);
  },
  [SET_LIST_OPTIONS_ACTION](context, listOptions) {
    context.commit(SET_LIST_OPTIONS, listOptions);
  },
  [SET_CURRENT_SESSION_STATE_ACTION](context, ids) {
    context.commit(SET_CURRENT_SESSION_STATE, ids);
  },
  [INIT_STATE_ACTION](context, ids) {
    context.commit(INIT_STATE, ids);
  },
};
